import styled from 'styled-components';
import { MOBILE, LARGE } from '@minerva-analytics/pantheon';
import { GRAY, DARK_GRAY, RED, BROWN } from '../../theme';

export const LegalContainer = styled.div`
  width: 70%;
  margin: 0 auto;
  padding-bottom: 1rem;
  @media (max-width: ${LARGE}) {
    width: 80%;
  }
  @media (max-width: ${MOBILE}) {
    width: 90%;
  }
  h1 {
    font-family: 'Abril Fatface', cursive;
    color: ${DARK_GRAY};

  }
  h2 {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    color: ${GRAY}
  }

  p, li{
    font-family: 'Inter', sans-serif;
    font-weight: normal;
    color: ${GRAY};
    font-size: 16px;
    line-height: 26px;
    letter-spacing: 0.6px;
  }

  a {
    color: ${RED};
  }
`;

export const LegalCard = styled.div`
  border-top: 1rem solid ${BROWN}; 
  padding: 1rem 2.5rem;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 10px 0px;
`;